import { AppchargeErrorType, EPaymentProvider, PaymentMethod } from '../contracts';

export const BLIK_CODE_LENGTH = 6;

const BLIK_CODE_REGEX = new RegExp(`^\\d{${BLIK_CODE_LENGTH}}$`);

export const isBlikCodeValid = (code: string): boolean => BLIK_CODE_REGEX.test(code);

// Stripe surfaces BLIK-specific decline reasons under these error codes when the
// shopper enters a bad/expired code or fails to approve the push in time. Anything
// else falls back to a generic decline message.
const BLIK_ERROR_CODE_TO_APPCHARGE_ERROR: Record<string, AppchargeErrorType> = {
  payment_method_invalid_parameter: AppchargeErrorType.BLIK_INVALID_CODE,
  payment_method_provider_timeout: AppchargeErrorType.BLIK_TIMEOUT,
};

export const mapBlikErrorCode = (errorCode?: string | null): AppchargeErrorType =>
  (errorCode && BLIK_ERROR_CODE_TO_APPCHARGE_ERROR[errorCode]) || AppchargeErrorType.GENERIC_DECLINE;

// Native BLIK finalizes an unconfirmed PaymentIntent: the backend creates it from
// the configured payment method (no client-created PaymentMethod / params), returns
// its client_secret, and the FE confirms client-side via stripe.confirmBlikPayment.
export const buildStripeBlikPaymentRequest = (paymentMethod: PaymentMethod, email: string) => ({
  paymentProvider: EPaymentProvider.stripe,
  receipt_email: email,
  params: {},
  paymentMethodDisplayName: paymentMethod.paymentMethodDisplayName,
  paymentMethodId: paymentMethod.id,
});
